module.exports = function() {
  return new Worker("/" + "parcel-html-transpiler.8c3a1a8a.worker.js");
};